export class PaymentMethodAction<TAction>
{
	type: string;
	value: TAction;

	constructor(type: string, value?: TAction)
	{
		if (type === null || type === undefined || type.length === 0)
		{
			throw new Error("type can't be null");
		}
		this.type = type;
		this.value = value;
	}
}


// WEBPACK FOOTER //
// ./src/actions/PaymentMethodActions.ts